module.exports = __webpack_public_path__ + "img/ms.af3c3e9b.svg";